import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {ApiResponseModel, ApiVisa} from "../shared";
import {Observable} from "rxjs";
import { PgwLabelListContainerModel } from '../../../../../models';
import { PgwLabelCriteriaModelQuery, PgwLabelQueryCriteriaClass } from '../../criteria';

@Injectable({
  providedIn: 'root'
})
export class PgwLabelListService extends BaseApiTemplateService<PgwLabelListContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + 'label-lists';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + 'label-lists';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + 'label-lists';
    this.httpClient = http;
  }
  getByCriteriaObservable(
    visa: ApiVisa, criteria?: PgwLabelQueryCriteriaClass
  ): Observable<ApiResponseModel<PgwLabelListContainerModel>> {
    const buildDocCriteria = new PgwLabelCriteriaModelQuery(criteria);
    const apiUrl = visa.api_domain_url + this.endpoint_path;
    const UrlByCriteria = apiUrl + '/query?' + buildDocCriteria.query;
    return this.httpClient.get<ApiResponseModel<PgwLabelListContainerModel>>
    (UrlByCriteria, this.getHttpHeader(visa));
  }
}
